module.exports = __webpack_public_path__ + "img/3.7e8af7b6.png";